export const blockIconsHardwareKeyboardDoubleArrowUp = (
	<span className='material-symbols-outlined'>keyboard_double_arrow_up</span>
);
